// Copyright (c) 2019 Deere & Company

export default Object.freeze({
    ADD_CLAIM_WEAR_PARTS_ADDITIONAL_REPAIR: 'ADD_CLAIM_WEAR_PARTS_ADDITIONAL_REPAIR',
    ADD_CLAIM_WEAR_PARTS_FILE: 'ADD_CLAIM_WEAR_PARTS_FILE',
    COPY_CLAIM_WEAR_PARTS: 'COPY_CLAIM_WEAR_PARTS',
    CREATE_CLAIM_WEAR_PARTS_LABOR: 'CREATE_CLAIM_WEAR_PARTS_LABOR',
    CREATE_CLAIM_WEAR_PARTS_OTHER_CREDIT: 'CREATE_CLAIM_WEAR_PARTS_OTHER_CREDIT',
    CREATE_CLAIM_WEAR_PARTS_PART: 'CREATE_CLAIM_WEAR_PARTS_PART',
    DELETE_CLAIM_WEAR_PARTS_FILE: 'DELETE_CLAIM_WEAR_PARTS_FILE',
    DELETE_CLAIM_WEAR_PARTS_LABOR: 'DELETE_CLAIM_WEAR_PARTS_LABOR',
    DELETE_CLAIM_WEAR_PARTS_OTHER_CREDIT: 'DELETE_CLAIM_WEAR_PARTS_OTHER_CREDIT',
    DELETE_CLAIM_WEAR_PARTS_PART: 'DELETE_CLAIM_WEAR_PARTS_PART',
    RESET_CLAIM_WEAR_PARTS: 'RESET_CLAIM_WEAR_PARTS',
    RESET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL: 'RESET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL',
    RESET_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN: 'RESET_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN',
    RESET_CLAIM_WEAR_PARTS_FORM_VALIDATION: 'RESET_CLAIM_WEAR_PARTS_FORM_VALIDATION',
    RESET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS: 'RESET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS',
    RESET_CLAIM_WEAR_PARTS_USE_AMOUNTS: 'RESET_CLAIM_WEAR_PARTS_USE_AMOUNTS',
    REVISE_CLAIM_WEAR_PARTS: 'REVISE_CLAIM_WEAR_PARTS',
    SET_CLAIM_WEAR_PARTS: 'SET_CLAIM_WEAR_PARTS',
    SET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL: 'SET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL',
    SET_CLAIM_WEAR_PARTS_CUSTOMER_DETAILS: 'SET_CLAIM_WEAR_PARTS_CUSTOMER_DETAILS',
    SET_CLAIM_WEAR_PARTS_PART_DETAILS: 'SET_CLAIM_WEAR_PARTS_PART_DETAILS',
    SET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS: 'SET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS',
    TOGGLE_CLAIM_WEAR_PARTS_WARRANTY_STATUS_MODAL: 'TOGGLE_CLAIM_WEAR_PARTS_WARRANTY_STATUS_MODAL',
    UPDATE_CLAIM_WEAR_PARTS_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_WEAR_PARTS_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_WEAR_PARTS_CLAIM_TYPES: 'UPDATE_CLAIM_WEAR_PARTS_CLAIM_TYPES',
    UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CAUSE: 'UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CAUSE',
    UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_WEAR_PARTS_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_ACCOUNT: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_ACCOUNT',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_FAILURE_DATE: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_FAILURE_DATE',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_DATE: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_DATE',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_NUMBER: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_NUMBER',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN',
    UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_VISIBILITY: 'UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_VISIBILITY',
    UPDATE_CLAIM_WEAR_PARTS_DOWN_TIME: 'UPDATE_CLAIM_WEAR_PARTS_DOWN_TIME',
    UPDATE_CLAIM_WEAR_PARTS_DTAC_CASE: 'UPDATE_CLAIM_WEAR_PARTS_DTAC_CASE',
    UPDATE_CLAIM_WEAR_PARTS_DTAC_SOLUTION: 'UPDATE_CLAIM_WEAR_PARTS_DTAC_SOLUTION',
    UPDATE_CLAIM_WEAR_PARTS_FAILED_AREA: 'UPDATE_CLAIM_WEAR_PARTS_FAILED_AREA',
    UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE: 'UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE',
    UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_WEAR_PARTS_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_WEAR_PARTS_FAILURE_DATE: 'UPDATE_CLAIM_WEAR_PARTS_FAILURE_DATE',
    UPDATE_CLAIM_WEAR_PARTS_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_WEAR_PARTS_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_WEAR_PARTS_FAILURE_PART: 'UPDATE_CLAIM_WEAR_PARTS_FAILURE_PART',
    UPDATE_CLAIM_WEAR_PARTS_FILE_LIST: 'UPDATE_CLAIM_WEAR_PARTS_FILE_LIST',
    UPDATE_CLAIM_WEAR_PARTS_FORM_VALIDATION: 'UPDATE_CLAIM_WEAR_PARTS_FORM_VALIDATION',
    UPDATE_CLAIM_WEAR_PARTS_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_WEAR_PARTS_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_WEAR_PARTS_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_WEAR_PARTS_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_WEAR_PARTS_IS_COPIED: 'UPDATE_CLAIM_WEAR_PARTS_IS_COPIED',
    UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE: 'UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE',
    UPDATE_CLAIM_WEAR_PARTS_IS_VALID_CLAIM: 'UPDATE_CLAIM_WEAR_PARTS_IS_VALID_CLAIM',
    UPDATE_CLAIM_WEAR_PARTS_LABOR_COMMENTS: 'UPDATE_CLAIM_WEAR_PARTS_LABOR_COMMENTS',
    UPDATE_CLAIM_WEAR_PARTS_LABOR_HOURS: 'UPDATE_CLAIM_WEAR_PARTS_LABOR_HOURS',
    UPDATE_CLAIM_WEAR_PARTS_LABOR_LOCATION: 'UPDATE_CLAIM_WEAR_PARTS_LABOR_LOCATION',
    UPDATE_CLAIM_WEAR_PARTS_LABOR_TYPE: 'UPDATE_CLAIM_WEAR_PARTS_LABOR_TYPE',
    UPDATE_CLAIM_WEAR_PARTS_MODAL_MODE: 'UPDATE_CLAIM_WEAR_PARTS_MODAL_MODE',
    UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMMENTS: 'UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMMENTS',
    UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_WEAR_PARTS_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_WEAR_PARTS_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_WEAR_PARTS_OWNERSHIP_STATUS: 'UPDATE_CLAIM_WEAR_PARTS_OWNERSHIP_STATUS',
    UPDATE_CLAIM_WEAR_PARTS_PART_FIELDS: 'UPDATE_CLAIM_WEAR_PARTS_PART_FIELDS',
    UPDATE_CLAIM_WEAR_PARTS_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_WEAR_PARTS_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_WEAR_PARTS_PART_UNIT: 'UPDATE_CLAIM_WEAR_PARTS_PART_UNIT',
    UPDATE_CLAIM_WEAR_PARTS_PIN: 'UPDATE_CLAIM_WEAR_PARTS_PIN',
    UPDATE_CLAIM_WEAR_PARTS_REMAN_INDICATOR: 'UPDATE_CLAIM_WEAR_PARTS_REMAN_INDICATOR',
    UPDATE_CLAIM_WEAR_PARTS_REPAIR_DATE: 'UPDATE_CLAIM_WEAR_PARTS_REPAIR_DATE',
    UPDATE_CLAIM_WEAR_PARTS_REPAIR_NUMBER: 'UPDATE_CLAIM_WEAR_PARTS_REPAIR_NUMBER',
    UPDATE_CLAIM_WEAR_PARTS_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_WEAR_PARTS_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_WEAR_PARTS_SERIAL_NUMBER: 'UPDATE_CLAIM_WEAR_PARTS_SERIAL_NUMBER',
    UPDATE_CLAIM_WEAR_PARTS_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_WEAR_PARTS_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_WEAR_PARTS_TECH_ID: 'UPDATE_CLAIM_WEAR_PARTS_TECH_ID',
    UPDATE_CLAIM_WEAR_PARTS_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_WEAR_PARTS_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT: 'UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT',
    UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNTS: 'UPDATE_CLAIM__WEAR_PARTS_USE_AMOUNTS',
    UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT_ON_PRODUCT_LOAD: 'UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT_ON_PRODUCT_LOAD',
    UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_WEAR_PARTS_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_ONE: 'UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_ONE',
    UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_TWO: 'UPDATE_CLAIM_WEAR_PARTS_WORK_ORDER_TWO'
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-list.js